import api from '../../apiConfig/apiConfig'
import { Get, Post, Put, Patch } from '../base/baseAjax'

let addService = function(param) {
  return Post({
    url: api.service.addService,
    bodyParam: param
  })
}
let editService = function(param) {
  return Put({
    url: api.service.editService,
    bodyParam: param
  })
}
let getServiceDetail = function(param) {
  return Get({
    url: api.service.getServiceDetail + param.id
  })
}

export function getWebsiteByCustomer(param) {
  return Get({
    url: api.service.getWebsiteByCustomer,
    UrlParam: param
  })
}
let getIndustryList = function(param) {
  return Get({
    url: api.service.getIndustryList,
    PathParam: param
  })
}

let industryReport = function(param) {
  return Post({
    url: api.service.industryReport,
    bodyParam: param
  })
}
let edmCupyNumcheck = function(param) {
  return Post({
    url: api.service.edmCupyNumcheck,
    bodyParam: param
  })
}
let fillbindinfo = function(param) {
  return Post({
    url: api.service.fillbindinfo,
    bodyParam: param
  })
}
let bindPhone = function(param) {
  return Post({
    url: api.service.bindPhone,
    bodyParam: param
  })
}
let startService = function(param) {
  return Patch({
    url: api.service.startService,
    PathParam: param
  })
}
export default {
  getServiceDetail,
  addService,
  editService,
  getWebsiteByCustomer,
  getIndustryList,
  industryReport,
  edmCupyNumcheck,
  fillbindinfo,
  bindPhone,
  startService
}
